/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Group color
 * @export
 */
export const ControlColor = {
    Gray: 'gray',
    Red: 'red',
    Orange: 'orange',
    Amber: 'amber',
    Green: 'green',
    Teal: 'teal',
    Blue: 'blue',
    Indigo: 'indigo',
    Purple: 'purple',
    Pink: 'pink'
} as const;
export type ControlColor = typeof ControlColor[keyof typeof ControlColor];


export function ControlColorFromJSON(json: any): ControlColor {
    return ControlColorFromJSONTyped(json, false);
}

export function ControlColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlColor {
    return json as ControlColor;
}

export function ControlColorToJSON(value?: ControlColor | null): any {
    return value as any;
}

